import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Foundation } from '../models/foundation';
import { Team } from '../models/team';

@Injectable({
  providedIn: 'root',
})
export class CurrentFoundationService {
  private localFoundation?: Foundation;
  private foundationSubject: BehaviorSubject<Foundation | undefined>;
  private teamSubject: BehaviorSubject<Team | undefined>;
  private pubnub: Subject<any> = new Subject<any>();
  private pubnubStatus: Subject<any> = new Subject<any>();
  private foundationUpdate: Subject<Foundation> = new Subject<Foundation>();
  private foundationDelete: Subject<Foundation> = new Subject<Foundation>();
  private winnersCount: Subject<boolean> = new Subject<boolean>();
  private team?: Team;

  constructor() {
    this.foundationSubject = new BehaviorSubject<Foundation | undefined>(
      this.localFoundation
    );
    this.teamSubject = new BehaviorSubject<Team | undefined>(this.team);
  }

  getWinnersCount(): Observable<boolean> {
    return this.winnersCount.asObservable();
  }

  setWinnersCount(callAcount: boolean): void {
    this.winnersCount.next(callAcount);
  }

  getFoundationUpdate(): Observable<Foundation> {
    return this.foundationUpdate.asObservable();
  }

  setFoundationUpdate(foundation: Foundation): void {
    this.foundationUpdate.next(foundation);
  }

  getFoundationDelete(): Observable<Foundation> {
    return this.foundationDelete.asObservable();
  }

  deleteFoundation(foundation: Foundation): void {
    this.foundationDelete.next(foundation);
  }

  getPubnubMessage(): Observable<any> {
    return this.pubnub.asObservable();
  }

  setPubnubMessage(message: any): void {
    this.pubnub.next(message);
  }

  getPubnubStatus(): Observable<any> {
    return this.pubnubStatus.asObservable();
  }

  setPubnubStatus(message: any): void {
    this.pubnubStatus.next(message);
  }

  getFoundationObs(): Observable<Foundation | undefined> {
    return this.foundationSubject.asObservable();
  }

  getFoundation(): Foundation | undefined {
    return this.localFoundation;
  }

  setFoundation(foundation?: Foundation): void {
    this.localFoundation = foundation;
    this.team = undefined;
    this.foundationSubject.next(this.localFoundation);
  }

  setTeam(team?: Team) {
    this.team = team;
    this.teamSubject.next(team);
  }

  getTeam(): Team | undefined {
    return this.team;
  }

  getTeamObs(): Observable<Team | undefined> {
    return this.teamSubject.asObservable();
  }

  clearData() {
    this.localFoundation = undefined;
    this.team = undefined;
    this.foundationSubject.next(this.localFoundation);
  }
}
